export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended',
  // AXF-1050 MD2: removed from the organisation (groups deleted, record kept). Staff routes still list it.
  REMOVED = 'removed',
}

export type TenantRole = 'Member' | 'TenantAdministrator'

export interface User {
  id: string
  email: string
  displayName: string
  avatarUrl?: string
  tenantRole?: TenantRole
  status: UserStatus
  isSuperAdmin: boolean
  isDevAdmin: boolean
  identityLinked: boolean
  tenantId?: string
  lastLoginAt?: string
  createdAt: string
  updatedAt?: string
}
